import React from 'react';
import { aiConversationService } from '@/lib/services';
import { createUseThemedStyles, useAiImage, useHandleError } from '@/hooks';
import { IMAGE_STATUS } from '@/contexts/ai-image-cache';

const useStyles = createUseThemedStyles((theme) => ({
	aiImageOuter: {
		padding: 5,
		borderRadius: 10,
		display: 'block',
		border: `1px solid ${theme.colors.gray300}`,
	},
	aiImageContainer: {
		borderRadius: 5,
		overflow: 'hidden',
		backgroundColor: theme.colors.gray600,
	},
	LoadingAndErrorOuter: {
		padding: 30,
		textAlign: 'center',
		color: theme.colors.gray400,
	},
	aiImage: {
		width: '100%',
		borderRadius: 5,
		display: 'block',
	},
}));

interface RemarkImageProps {
	alt: string;
	src: string;
}

export const AiImage = React.memo(({ alt, src }: RemarkImageProps) => {
	const classes = useStyles();
	const handleError = useHandleError();
	const state = useAiImage(src, async () => {
		if (isValidUrl(src)) {
			return src;
		}

		try {
			const parts = src.split('/').filter(Boolean);

			if (parts.length !== 2) {
				return '';
			}

			const imageFileName = parts[parts.length - 1];
			const containerId = parts[parts.length - 2];
			const response = await aiConversationService.getConverstaionImage(containerId, imageFileName).fetch();

			return response.signedUrl;
		} catch (error) {
			handleError(error);
			return '';
		}
	});

	const isValidUrl = (text: string) => {
		try {
			new URL(text);
			return true;
		} catch {
			return false;
		}
	};

	if (state.status === IMAGE_STATUS.IDLE) {
		return null;
	}

	return (
		<div className={classes.aiImageOuter}>
			<div className={classes.aiImageContainer}>
				{state.status === IMAGE_STATUS.LOADING && (
					<div className={classes.LoadingAndErrorOuter}>Loading Image...</div>
				)}

				{state.status === IMAGE_STATUS.ERROR && (
					<div className={classes.LoadingAndErrorOuter}>Error Loading Image</div>
				)}

				{state.status === IMAGE_STATUS.READY && <img className={classes.aiImage} alt={alt} src={state.url} />}
			</div>
		</div>
	);
});
